import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import {
  getSessionRemainingMs,
  getStoredLogoutTimeMs,
  LOGOUT_TIMER_START_KEY,
} from "../generator/utils/refreshLogoutTimer";
import { getApiAuthData } from "../utils";
import { useElectronApiReady } from "./useElectronApiReady";
import { useLogout } from "./useLogout";
import { useIsThemeLoading, useThemeFlags } from "./useThemeFlags";

let judgedStart: string | null = null;
let judgedExpired = false;

export const resetExpiredSessionCheck = () => {
  judgedStart = null;
  judgedExpired = false;
};

const isSessionExpiredOnLoad = (): boolean => {
  const start = localStorage.getItem(LOGOUT_TIMER_START_KEY);
  if (judgedStart !== null && judgedStart === start) return judgedExpired;

  const logoutTimeMs = getStoredLogoutTimeMs();
  if (logoutTimeMs === null) return false;

  const remaining = getSessionRemainingMs(logoutTimeMs);
  if (remaining === null) return false;

  judgedStart = start;
  judgedExpired = remaining <= 0;
  return judgedExpired;
};

export const useExpiredSessionRedirect = (): boolean => {
  const logout = useLogout();
  const electronApiReady = useElectronApiReady();
  const isThemeLoading = useIsThemeLoading();
  const flags = useThemeFlags();
  const { pathname } = useLocation();
  const { _userid } = getApiAuthData();

  const isSkipped =
    electronApiReady ||
    isThemeLoading ||
    Boolean(flags.hideLogoutTimer) ||
    pathname.includes("/exports") ||
    !_userid;

  const isExpired = !isSkipped && isSessionExpiredOnLoad();

  useEffect(() => {
    if (isExpired) void logout();
  }, [isExpired, logout]);

  return isExpired;
};
